import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-secondary',
  imports: [RouterLink],
  template: `
    <div
      class="bg-primary d-flex align-items-center flex-column p-5 m-3 m-md-5"
    >
      <h1 class="text-white mb-4">¡Conoce la Agenda de la UDEP!</h1>

      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <p class="text-center text-white-50">
            Nuestra comunidad académica y deportiva se proyecta dentro y fuera
            del aula. ¡Conoce aquí los diferentes eventos que organizamos,
            impulsando el talento, la disciplina y el espíritu deportivo de los
            poblanos!
          </p>
        </div>
      </div>

      <button class="btn btn-outline-light rounded-0 mt-4" routerLink="/agenda">
        Agenda
      </button>
    </div>

    <footer class="footer mt-auto py-5 bg-primary">
      <div class="container text-center">
        <div class="d-flex justify-content-between flex-column flex-lg-row">
          <div class="d-flex flex-column align-items-start text-white">
            <h4>Ubicación de la UDEP</h4>

            <div class="row">
              <div class="col-12 col-lg-7">
                <p class="text-start text-secondary">
                  Las instalaciones de la Universidad del Deporte se encuentran
                  dentro del histórico Estadio Ignacio Zaragoza, ubicado en
                  Calzada de los Fuertes # 2806, C.P. 72260, Puebla, Puebla.
                </p>
              </div>
            </div>
          </div>

          <div
            class="text-white d-flex flex-column align-items-start mt-4 mt-lg-0"
          >
            <h4>¡Contáctanos!</h4>

            <p class="text-white">Encuéntranos en nuestras redes sociales</p>
            <p class="text-white mb-0">O escríbenos un correo electrónico a</p>
            <a
              href="mailto:admisiones&#64;universidaddeldeporte.edu.mx"
              class="text-white text-decoration-none"
            >
              admisiones&#64;universidaddeldeporte.edu.mx
            </a>
          </div>
        </div>

        <hr class="border border-light" />

        <div class="d-flex flex-column flex-md-row gap-md-4">
          <a
            class="text-white text-decoration-none"
            routerLink="/terminos-y-condiciones"
          >
            Términos y condiciones
          </a>

          <a
            class="text-white text-decoration-none"
            routerLink="/aviso-de-privacidad"
          >
            Aviso de privacidad
          </a>

          <a class="text-white text-decoration-none" routerLink="/finanzas">
            Información financiera
          </a>

          <a class="text-white text-decoration-none" routerLink="/integridad">
            Integridad
          </a>

          <a class="text-white text-decoration-none" routerLink="/desarrollo-archivistico">
            Desarrollo Archivístico
          </a>

          <a class="text-white text-decoration-none" routerLink="/inventario-capitalizable">
            Inventario Capitalizable
          </a>

          <a class="text-white text-decoration-none" routerLink="/documentos-de-referencia">
            Documentos de Referencia
          </a>

          <a class="text-white text-decoration-none" routerLink="/comites">
            Comités
          </a>
        </div>

        <hr class="border border-light" />

        <span class="text-secondary mt-4">
          Todos los derechos reservados &copy; UDEP 2026
        </span>
      </div>
    </footer>
  `,
  styles: ``
})
export class FooterSecondaryComponent {}
